// Injections and drips given here one dose per visit (owner's decision, 2026-09-30). Mirrors the
// backend's ClinicCourse, which has the final say: the server keeps the doctor's choice only on a
// line that can be a course, and fills in "given here" where nothing was said.

// Doses a day, the same counts the backend's DispenseQty and ClinicCourse use.
const PER_DAY = {
  ONCE_DAILY: 1, DAILY: 1,
  TWICE_DAILY: 2, EVERY_12_HOURS: 2,
  THRICE_DAILY: 3, EVERY_8_HOURS: 3,
  FOUR_TIMES: 4, EVERY_6_HOURS: 4,
  EVERY_4_HOURS: 6,
};

/** Doses a day, or one dose every so many days; null when there is no schedule to follow. */
const scheduleOf = (line) => {
  const f = line.frequency;
  if (!f) {
    // Written as doses per time of day: each slot with a dose is one visit's worth.
    const slots = [line.doseMorning, line.doseAfternoon, line.doseEvening, line.doseNight]
      .filter((d) => Number(d) > 0).length;
    return slots > 0 ? { perDay: slots } : null;
  }
  if (PER_DAY[f]) return { perDay: PER_DAY[f] };
  if (f === 'WEEKLY') return { everyDays: 7 };
  if (f === 'EVERY_N_DAYS') {
    const n = parseInt(line.frequencyIntervalDays, 10);
    return n >= 2 ? { everyDays: n } : null;
  }
  return null; // STAT, AS_NEEDED: a single dose or no schedule at all
};

/** How many times the medicine is given over the course; 0 when it has no countable schedule. */
export const courseDoses = (line) => {
  if (!line) return 0;
  const value = parseInt(line.durationValue, 10);
  if (line.durationUnit === 'DOSES') return value > 0 ? value : 0;
  if (line.durationUnit === 'CONTINUOUS' || line.durationUnit === 'UNTIL_FINISHED') return 0;
  if (!(value > 0)) return 0;
  const s = scheduleOf(line);
  if (!s) return 0;
  const days = line.durationUnit === 'WEEKS' ? value * 7 : line.durationUnit === 'MONTHS' ? value * 30 : value;
  return s.perDay ? s.perDay * days : Math.ceil(days / s.everyDays);
};

/** Whether the line can be given here one dose per visit: a stocked injection with doses to spread. */
export const canBeGivenHere = (line, { external = false } = {}) =>
  !external
  && String(line?.medicineType || '').toUpperCase().includes('INJECT')
  && courseDoses(line) > 1;

/** Whether a saved line IS given here one dose per visit (the server settled the flag). */
export const isGivenHere = (line) => line?.givenAtClinic === true;
